export const isKycVerifiedStatus = (status?: string | null): boolean =>
  status?.toUpperCase() === "VERIFIED";

export const getKycState = (
  status?: string | null,
  attempt?: string | null
): "verified" | "rejected" | "pending" | "expired" | "unknown" => {
  const normalizedStatus = status?.toUpperCase() ?? "";
  const normalizedAttempt = attempt?.toUpperCase() ?? "";

  if (normalizedStatus === "VERIFIED") {
    return "verified";
  }

  if (normalizedStatus === "EXPIRED") {
    return "expired";
  }

  if (
    normalizedAttempt === "REJECTED" ||
    normalizedAttempt === "REJECTED_BY_PROVIDER" ||
    normalizedAttempt === "REJECTED_BY_RISK"
  ) {
    return "rejected";
  }

  if (
    normalizedAttempt === "CREATED" ||
    normalizedAttempt === "PENDING" ||
    normalizedAttempt === "VERIFICATION" ||
    normalizedAttempt === "SUCCESSFUL"
  ) {
    return "pending";
  }

  return "unknown";
};
